import { Column } from '@ru-digital-assets/ui-component/dist/stories/table';
import { IKeyRecoveryInfo } from 'constants/key-recovery';
import RestoreKeyStatus from './RestoreKeyStatus';

export const getColumns = (): Column<IKeyRecoveryInfo>[] => {
  return [
    {
      title: 'Операция',
      name: 'operation',
      headerStyle: {
        width: '30%',
      },
      dataGetter: () => 'Восстановление Ключа',
    },
    {
      title: 'Пользователь',
      name: 'user',
      headerStyle: {
        width: '30%',
      },
      dataGetter: (data) => data.initiatorName,
    },
    {
      title: 'Пользователь',
      name: 'organization',
      headerStyle: {
        width: '30%',
      },
      dataGetter: (data) => data.organizationName,
    },
    {
      title: '',
      name: 'status',
      headerStyle: {
        width: '10%',
        borderLeft: 0,
      },
      dataGetter: (data) => data,
      Component: ({ data }: { data: IKeyRecoveryInfo }) => {
        return (
          <div className="flex justify-end">
            <RestoreKeyStatus status={data.status} />
          </div>
        );
      },
    },
  ];
};
